import editorialStyle from "../../../components/editorial/style.scss";

import { Fragment } from "preact";
import Link, {
  Button,
  ButtonList,
  ButtonBar,
  LargeViewOnly,
  StickyButtons,
  affiliateMerchants,
} from "../../../components/link";
import AffiliateDisclosure from "../../../components/affiliate-disclosure";
import Center from "../../../components/center";
import Editorial from "../../../components/editorial";
import FixedTable from "../../../components/fixed-table";
import Head from "../../../components/head";
import Hero from "../../../components/hero";
import ImageSet from "../../../components/image-set";
import Image from "../../../components/image";
import Tags from "../../../components/tags";
import Author from "../../../components/author";
import EcoFlowCouponCode from "../components/coupon-code";
import NoWrap from "../../../components/no-wrap";
import SlugHeading from "../../../components/slug-heading";
import SlugLink from "../../../components/slug-link";
import Accordion from "../../../components/accordion";
import AccordionPreview from "../../../components/accordion/preview";
import PhotoListItem from "../../../components/photo-list-item";
import ReviewItem from "../../../components/review-item";
import Questions from "../../../components/questions";
import namedRoutes from "../../../settings/routes";
import { lookupByUrl } from "../../../settings/route-data-lookup";

let headerInfo = lookupByUrl(namedRoutes.ecoflow.d3air);

const Page = () => (
  <div>
    <Head data={headerInfo} />
    <Hero
      positionX={0}
      positionY={71}
      //background="https://websiteoss.ecoflow.com/upload/image/1763522074447/work.jpg"
      background="/images/products/ecoflow/delta-3-1000-air/banner.webp"
      titlePrefix="EcoFlow"
      title="DELTA 3 Air Series"
      subTitle="1000 & 2000 Air Models"
    />
    <Editorial>
      <Center>
        <Author
          published={headerInfo.datePublished}
          updated={headerInfo.dateModified}
        />

        <LargeViewOnly>
          <ButtonList>
            <Button
              size="medium"
              affiliateData={affiliateMerchants.ecoflow}
              href="https://us.ecoflow.com/products/delta-3-1000-air-10ms-ups-portable-power-station?variant=54810612793417"
              icon="EcoFlow"
            >
              View DELTA 3 1000 Air
            </Button>
            <Button
              size="medium"
              affiliate="https://amzn.to/45gpfWv"
              href="https://www.amazon.com/dp/B0G15GWNZQ/"
              secondary
              icon="Amazon"
            >
              View on Amazon
            </Button>
          </ButtonList>
        </LargeViewOnly>

        <p>
          EcoFlow’s <strong>DELTA 3 Air Series</strong> introduces two mid-range
          portable power stations, the{" "}
          <strong>
            {" "}
            <Link
              affiliateData={affiliateMerchants.ecoflow}
              href="https://us.ecoflow.com/products/delta-3-1000-air-10ms-ups-portable-power-station?variant=54810612793417"
            >
              DELTA 3 1000 Air
            </Link>
          </strong>{" "}
          and <strong>DELTA 3 2000 Air</strong>, designed to balance
          portability, reliability, and flexible backup power. This series
          successfully breaks away from the 'bigger is better' trend by focusing
          on grid stability. While these units lack the massive AC power output
          of their larger EcoFlow DELTA siblings, they compensate with a sleek,
          lightweight design and sub 10ms uninterruptible power supply (UPS).
        </p>
        {/* <p>
          The DELTA 3 2000 Air is not yet available for purchase. This review will
          be updated once more information is available.
        </p> */}
        <p>
          The DELTA 3 2000 Air is not yet available for purchase. This review
          will be updated when official details are released and as I gain more
          long-term experience with the DELTA 3 1000 Air.
        </p>

        <AffiliateDisclosure />

        <ImageSet
          showAlt
          border={true}
          images={[
            {
              lg: "/images/products/ecoflow/delta-3-1000-air/front.webp",
              alt: "EcoFlow DELTA 3 1000 Air",
            },
            {
              lg: "/images/products/ecoflow/delta-3-1000-air/front-right.webp",
              alt: "EcoFlow DELTA 3 1000 Air",
            },
            {
              lg: "/images/products/ecoflow/delta-3-2000-air/front.webp",
              alt: "EcoFlow DELTA 3 2000 Air (Philippine model)",
            },
            {
              lg: "/images/products/ecoflow/delta-3-2000-air/front-left.webp",
              alt: "EcoFlow DELTA 3 2000 Air (Philippine model)",
            },
          ]}
        />

        <Accordion
          items={[
            {
              heading: "Table of Contents",
              content: (
                <ol>
                  <li>
                    <SlugLink>Photos</SlugLink>
                  </li>
                  <li>
                    <SlugLink>Highlights</SlugLink>
                  </li>
                  <li>
                    <SlugLink>Considerations</SlugLink>
                  </li>
                  <li>
                    <SlugLink>Best Uses</SlugLink>
                  </li>
                  <li>
                    <SlugLink>Detailed Comparison</SlugLink>
                  </li>
                  <li>
                    <SlugLink>App Control</SlugLink>
                  </li>
                  <li>
                    <SlugLink>Accessories</SlugLink>
                  </li>
                  <li>
                    <SlugLink>My Verdict</SlugLink>
                  </li>
                </ol>
              ),
            },
          ]}
        />
      </Center>
      <Center>
        <SlugHeading tag="h2">Photos</SlugHeading>
        <ImageSet
          size={3}
          images={[
            {
              lg: "/images/products/ecoflow/delta-3-1000-air/lg/1852.webp",
              sm: "/images/products/ecoflow/delta-3-1000-air/sm/1852.webp",
              alt: "DELTA 3 1000 Air: plugged in front right",
            },
            {
              lg: "/images/products/ecoflow/delta-3-1000-air/lg/1851.webp",
              sm: "/images/products/ecoflow/delta-3-1000-air/sm/1851.webp",
              alt: "DELTA 3 1000 Air: plugged in front",
            },
            {
              lg: "/images/products/ecoflow/delta-3-1000-air/lg/1853.webp",
              sm: "/images/products/ecoflow/delta-3-1000-air/sm/1853.webp",
              alt: "DELTA 3 1000 Air: plugged in front left",
            },
            {
              lg: "/images/products/ecoflow/delta-3-1000-air/lg/1857.webp",
              sm: "/images/products/ecoflow/delta-3-1000-air/sm/1857.webp",
              alt: "DELTA 3 1000 Air: right",
            },
            {
              lg: "/images/products/ecoflow/delta-3-1000-air/lg/1858.webp",
              sm: "/images/products/ecoflow/delta-3-1000-air/sm/1858.webp",
              alt: "DELTA 3 1000 Air: back",
            },
            {
              lg: "/images/products/ecoflow/delta-3-1000-air/lg/1859.webp",
              sm: "/images/products/ecoflow/delta-3-1000-air/sm/1859.webp",
              alt: "DELTA 3 1000 Air: left",
            },
            {
              lg: "/images/products/ecoflow/delta-3-1000-air/lg/1856.webp",
              sm: "/images/products/ecoflow/delta-3-1000-air/sm/1856.webp",
              alt: "DELTA 3 1000 Air: front right",
            },
            {
              lg: "/images/products/ecoflow/delta-3-1000-air/lg/1855.webp",
              sm: "/images/products/ecoflow/delta-3-1000-air/sm/1855.webp",
              alt: "DELTA 3 1000 Air: front",
            },
            {
              lg: "/images/products/ecoflow/delta-3-1000-air/lg/1854.webp",
              sm: "/images/products/ecoflow/delta-3-1000-air/sm/1854.webp",
              alt: "DELTA 3 1000 Air: front left",
            },
          ]}
        />
      </Center>
      <Center>
        <SlugHeading tag="h2">Highlights</SlugHeading>
        <ul>
          <li>
            <strong>Portable:</strong> Weighing only 22 lbs (1000 Air) and 40
            lbs (2000 Air), with a sturdy handle that makes both easy to carry.
          </li>
          <li>
            <strong>UPS switchover:</strong> The switchover is under 10ms,
            keeping computers, CPAP machines, and other equipment continuously
            powered.
          </li>
          <li>
            <strong>AC power:</strong> The standard wall outlet provides
            continuous 500W (1000 Air) or 1000W (2000 Air) of reliable power.
          </li>
          <li>
            <strong>Passthrough charging:</strong> Powers devices while charging
            for uninterrupted use.
          </li>
          <li>
            <strong>Adjustable charge rate:</strong> User‑selectable AC amperage
            allows charging slower or faster, with full recharge in about two
            hours.
          </li>
          <li>
            <strong>USB ports:</strong> Includes USB-A and USB-C ports for
            charging phones and other devices.
          </li>
          <li>
            <strong>App control:</strong> Wi-Fi and Bluetooth connectivity allow
            control and monitoring through the EcoFlow app.
          </li>
          <li>
            <strong>LFP battery:</strong> LiFePO₄ chemistry ensures durability
            and long service life under constant use.
          </li>
        </ul>
      </Center>
      <Center>
        <SlugHeading tag="h2">Considerations</SlugHeading>
        <ul>
          <li>
            <strong>Short‑duration backup:</strong> Best suited for short-term
            backup of select devices rather than extended outages.
          </li>
          <li>
            <strong>Limited AC output:</strong> Rated at 500W (1000 Air) and
            1000W (2000 Air), these units cannot power a microwave, space
            heater, hair dryer, or similar appliances.
          </li>
          <li>
            <strong>Slower AC charging:</strong> AC charging is capped at 500W
            (1000 Air) and 1000W (2000 Air) which is less than some DELTA power
            stations.
          </li>
          <li>
            <strong>No 12V car socket:</strong> Lacks the standard DC cigarette
            lighter port found on many power stations.
          </li>
          <li>
            <strong>No expansion:</strong> Unlike many DELTA power stations, the
            Air series does not support expansion batteries.
          </li>
          <li>
            <strong>Fewer ports:</strong> The streamlined port selection offers
            less flexibility, though a power strip can extend capacity.
          </li>
          <li>
            <strong>Not silent:</strong> EcoFlow advertises "&lt; 39 dB
            whisper-quiet operation," which can imply near-silence. My testing
            confirmed these levels, yet the fan noise was still noticeable and
            similar to a small computer fan even as the lowest AC charge setting
            (50W).
          </li>
          <li>
            <strong>Appliance limitations:</strong> Product diagrams suggest the
            1000 Air can power an 800W kettle or 600W coffee maker, but these
            represent unusually low-wattage models. Standard household kettles
            (~1,200W+) and coffee makers (~900W+) exceed this unit's 500W limit
            (and 800W X-Boost) and will not function.
          </li>
          <li>
            <strong>Storage:</strong> Proper storage is required to maintain
            battery health and preserve warranty coverage.
          </li>
          <li>
            <strong>Warranty:</strong> Coverage lasts 2 years, compared to the
            5‑year protection available on some DELTA models.
          </li>
        </ul>

        <Accordion
          headingsAs="h3"
          items={[
            {
              heading: "Feedback to EcoFlow",
              content: (
                <ul>
                  <li>
                    <strong>Grid voltage thresholds:</strong> The manual doesn't
                    specify the exact voltage levels that trigger the red or
                    orange "High" and "Low" status lights.
                  </li>
                  <li>
                    <strong>App monitoring:</strong> The app doesn't display the
                    real-time grid voltage status shown on the unit's front
                    panel. Additionally, users would benefit from a historical
                    chart (e.g., 7-day log) to track voltage fluctuations over
                    time.
                  </li>
                  <li>
                    <strong>Time format:</strong> Task scheduling forces a
                    24-hour clock, which is inconvenient for some users. The app
                    should automatically match the mobile device’s system time
                    format (12h vs 24h).
                  </li>
                  <li>
                    <strong>Fan noise:</strong> There is a negligible difference
                    in noise levels between the minimum and maximum AC charging
                    rates. Unexpectedly, the fan remains noticeable even at the
                    lowest charge rate (50W).
                  </li>
                  <li>
                    <strong>Surge duration:</strong> The duration of the surge
                    is not documented, which is an important detail for anyone
                    needing this feature.
                  </li>
                  <li>
                    <strong>Missing app data:</strong> The "Specifications"
                    section within the app is currently empty, displaying only
                    the serial number.
                  </li>
                  <li>
                    <strong>X-Boost default setting:</strong> X-Boost is
                    currently enabled by default. However, the manual notes that
                    this mode lowers voltage, causing devices with voltage
                    protection to stop working. To prevent compatibility issues
                    with sensitive equipment, X-Boost should be disabled by
                    default, allowing users to manually enable it only when they
                    specifically need to power heavy resistive loads.
                  </li>
                  <li>
                    <strong>Battery cycles:</strong> Unlike other EcoFlow
                    products, the Air series does not list its battery cycle
                    rating. This is critical information for customers
                    evaluating a long‑term investment in a power station.
                  </li>
                  <li>
                    <strong>Include more ports:</strong> Requiring an external
                    power strip for multiple devices undermines the product’s
                    elegant design. At a minimum, the 1000 Air should offer 2 AC
                    ports and 4 USB ports, while the 2000 Air should provide 4
                    AC ports and 6 USB ports. The front panel has ample unused
                    space that could accommodate these additions.
                  </li>
                  <li>
                    <strong>Warranty:</strong> Every other DELTA 3 model
                    includes a 5-year warranty (
                    <Link
                      affiliateData={affiliateMerchants.ecoflow}
                      href="https://us.ecoflow.com/pages/warranty-policy"
                    >
                      see policy
                    </Link>
                    ). Limiting the Air series to 2 years signals that it is not
                    a full member of the DELTA lineup.
                  </li>
                  <li>
                    <strong>Model confusion:</strong> Offering two different
                    1000 Air models with varying UPS switchover times (10ms and
                    20ms) creates unnecessary confusion for customers.
                  </li>
                </ul>
              ),
            },
          ]}
        />
      </Center>
      <Center>
        <SlugHeading tag="h2">Best Uses</SlugHeading>
        <p>
          Engineered for regions with unstable grids, this unit features
          indicators that display real-time voltage conditions (low, normal,
          high). While built to handle brownouts, it also excels in these
          scenarios:
        </p>
        <ul>
          <li>
            <strong>Home office:</strong> With &lt;10ms UPS switchover, this is
            the ultimate safeguard for remote workers, keeping your desktop
            computer and router online through grid instability.
          </li>
          <li>
            <strong>3D Printing:</strong> Provides a stable buffer so momentary
            power blips do not ruin long print jobs.
          </li>
          <li>
            <strong>Medical devices:</strong> Offers reliable backup for CPAP
            machines and other low‑wattage equipment.
          </li>
          <li>
            <strong>Outdoor adventures:</strong> Lightweight design is great for
            camping or tailgating with portable power.
          </li>
        </ul>

        <ImageSet
          size={2}
          images={[
            {
              lg: "/images/products/ecoflow/delta-3-1000-air/lg/1899.webp",
              sm: "/images/products/ecoflow/delta-3-1000-air/sm/1899.webp",
              alt: "DELTA 3 1000 Air powering desktop computer",
            },
            {
              lg: "/images/products/ecoflow/delta-3-1000-air/lg/1886.webp",
              sm: "/images/products/ecoflow/delta-3-1000-air/sm/1886.webp",
              alt: "DELTA 3 1000 Air powering 3D printer",
            },
          ]}
        />
        <p>
          Personally, I’m excited to use the DELTA 3 1000 Air with either my
          desktop computer or 3D printer, since both will benefit from its quick
          UPS response and reliable power delivery.
        </p>
      </Center>
      <Center>
        <SlugHeading tag="h2">Detailed Comparison</SlugHeading>
        <p>
          Here’s a side‑by‑side breakdown of the{" "}
          <strong>DELTA 3 1000 Air</strong> and{" "}
          <strong>DELTA 3 2000 Air</strong>:
        </p>
        <p class="caption-left">
          Note: Specs are listed for the US model; please check the manual for
          regional variations.
        </p>

        <Fragment>
          <FixedTable>
            <table>
              <thead>
                <tr>
                  <th class={editorialStyle.sticky}>Model</th>
                  <th>DELTA 3 1000 Air</th>
                  <th>DELTA 3 2000 Air</th>
                </tr>
              </thead>
              <tbody>
                <tr class={editorialStyle.noHover}>
                  <th class={editorialStyle.sticky}>
                    <strong>Photo</strong>
                  </th>
                  <td>
                    <Image
                      src="/images/products/ecoflow/delta-3-1000-air/front.webp"
                      alt="EcoFlow DELTA 3 1000 Air"
                      showAlt
                      maxHeight={200}
                    />
                  </td>
                  <td>
                    <Image
                      src="/images/products/ecoflow/delta-3-2000-air/front.webp"
                      alt="EcoFlow DELTA 3 2000 Air (Philippine model)"
                      showAlt
                      maxHeight={200}
                    />
                  </td>
                </tr>
                <tr class={editorialStyle.noHover}>
                  <th class={editorialStyle.sticky}>
                    <strong>Links</strong>
                  </th>
                  <td>
                    <ButtonBar>
                      <Button
                        size="small"
                        affiliateData={affiliateMerchants.ecoflow}
                        href="https://us.ecoflow.com/products/delta-3-1000-air-10ms-ups-portable-power-station?variant=55333221433417"
                        icon="EcoFlow"
                      >
                        Store
                      </Button>
                      <Button
                        size="small"
                        affiliateData={affiliateMerchants.ecoflow}
                        href="https://manuals.ecoflow.com/us/product/delta-3-1000-air"
                        secondary
                      >
                        Manual
                      </Button>
                    </ButtonBar>
                  </td>
                  <td>
                    <ButtonBar>
                      <Button
                        size="small"
                        affiliateData={affiliateMerchants.ecoflow}
                        href="https://ph.ecoflow.com/products/delta-3-air-series-portable-power-station?variant=53215190221110"
                        icon="EcoFlow"
                      >
                        Philippines
                      </Button>
                      <Button
                        size="small"
                        affiliateData={affiliateMerchants.ecoflow}
                        href="https://manuals.ecoflow.com/us/product/delta-3-2000-air"
                        secondary
                      >
                        Manual
                      </Button>
                    </ButtonBar>
                  </td>
                </tr>
                <tr>
                  <th class={editorialStyle.sticky}>
                    <strong>Price</strong>
                  </th>
                  <td>
                    $309 <s>$499</s>
                  </td>
                  <td>TBD</td>
                </tr>
                <tr class={editorialStyle.rowBorder}>
                  <th class={editorialStyle.sticky}>
                    <strong>Capacity</strong>
                  </th>
                  <td>960Wh</td>
                  <td>1,920Wh</td>
                </tr>
                <tr class={editorialStyle.rowBorder}>
                  <th class={editorialStyle.sticky}>
                    <strong>AC output</strong>
                  </th>
                  <td>
                    total: 500W
                    <br />
                    surge: 1,000W
                    <br />
                    X-boost: 800W
                  </td>
                  <td>
                    total: 1,000W
                    <br />
                    surge: TBD
                    <br />
                    X-boost: TBD
                  </td>
                </tr>
                <tr>
                  <th class={editorialStyle.sticky}>
                    <strong>
                      <NoWrap>UPS switchover</NoWrap>
                    </strong>
                  </th>
                  <td>
                    &lt;10ms <sup>1</sup>
                  </td>
                  <td>&lt;10ms</td>
                </tr>
                <tr>
                  <th class={editorialStyle.sticky}>
                    <strong>AC ports</strong>
                  </th>
                  <td>1×</td>
                  <td>2×</td>
                </tr>
                <tr>
                  <th class={editorialStyle.sticky}>
                    <strong>USB A</strong>
                  </th>
                  <td>1×</td>
                  <td>2×</td>
                </tr>
                <tr>
                  <th class={editorialStyle.sticky}>
                    <strong>USB C</strong>
                  </th>
                  <td>1×</td>
                  <td>2×</td>
                </tr>
                <tr class={editorialStyle.rowBorder}>
                  <th class={editorialStyle.sticky}>
                    <strong>AC input</strong>
                  </th>
                  <td>
                    100-120V~5.5A
                    <br />
                    500W
                  </td>
                  <td>1000W</td>
                </tr>
                <tr>
                  <th class={editorialStyle.sticky}>
                    <strong>
                      <NoWrap>Solar input 1</NoWrap>
                    </strong>
                  </th>
                  <td>
                    12-60V⎓15A
                    <br />
                    500W
                  </td>
                  <td>
                    12-60V⎓15A
                    <br />
                    500W
                  </td>
                </tr>
                <tr>
                  <th class={editorialStyle.sticky}>
                    <strong>
                      <NoWrap>Solar input 2</NoWrap>
                    </strong>
                  </th>
                  <td>--</td>
                  <td>TBD</td>
                </tr>
                <tr class={editorialStyle.rowBorder}>
                  <th class={editorialStyle.sticky}>
                    <strong>Size (in)</strong>
                  </th>
                  <td>8.6 × 8.8 × 10.3"</td>
                  <td>8.6 × 8.8 × 16.8"</td>
                </tr>
                <tr>
                  <th class={editorialStyle.sticky}>
                    <strong>Size (mm)</strong>
                  </th>
                  <td>
                    <NoWrap>220 × 223 × 263 mm</NoWrap>
                  </td>
                  <td>
                    <NoWrap>220 × 223 × 426 mm</NoWrap>
                  </td>
                </tr>
                <tr>
                  <th class={editorialStyle.sticky}>
                    <strong>Weight</strong>
                  </th>
                  <td>
                    <NoWrap>21.8lbs (9.9kg)</NoWrap>
                  </td>
                  <td>
                    <NoWrap>39.2lbs (17.8kg)</NoWrap>
                  </td>
                </tr>
              </tbody>
            </table>
          </FixedTable>
          <p class="caption">
            <strong>1.</strong> On some international models, the UPS
            (uninterruptible power supply) switchover is rated for &lt;20ms
            instead of &lt;10ms.
          </p>
        </Fragment>

        <Accordion
          headingsAs="h3"
          items={[
            {
              heading: "Additional Specifications - 1000 Air",
              content: (
                <Fragment>
                  <h4>General</h4>
                  <ul style="font-size:0.9em;">
                    <li>
                      <strong>Model:</strong> EF-DL3-A
                    </li>
                    <li>
                      <strong>Net Weight:</strong> 21.8lbs (9.9kg)
                    </li>
                    <li>
                      <strong>Dimensions:</strong> 8.6 × 8.8 × 10.3 in{" "}
                      <NoWrap>(220 × 223 × 263 mm)</NoWrap>
                    </li>
                    <li>
                      <strong>Overvoltage Category:</strong> II
                    </li>
                    <li>
                      <strong>Warranty period:</strong> 2 years
                    </li>
                    <li>
                      <strong>Noise level:</strong> &lt; 39 dB
                    </li>
                  </ul>
                  <hr />
                  <h4>Battery Info</h4>
                  <ul style="font-size:0.9em;">
                    <li>
                      <strong>Rated Capacity:</strong> 960Wh (9.6V⎓100Ah)
                    </li>
                    <li>
                      <strong>Cell Chemistry:</strong> LFP (LiFePO₄)
                    </li>
                    <li>
                      <strong>Protection Type:</strong> Over Voltage Protection,
                      Overload Protection, Over Temperature Protection, Short
                      Circuit Protection, Low Temperature Protection, Low
                      Voltage Protection, Overcurrent Protection
                    </li>
                  </ul>
                  <hr />
                  <h4>Output</h4>
                  <ul style="font-size:0.9em;">
                    <li>
                      <strong>AC Output Socket (Discharge Only) (US):</strong>{" "}
                      120V~60Hz 500W, Surge 1000W, <NoWrap>X-boost 800W</NoWrap>
                    </li>
                    <li>
                      <strong>USB-A Output:</strong> 5V⎓2.4A, 12W Max
                    </li>
                    <li>
                      <strong>USB-C Output:</strong> 5V⎓3A / 9V⎓2A / 12V⎓1.5A,
                      18W Max
                    </li>
                  </ul>
                  <hr />
                  <h4>Input</h4>
                  <ul style="font-size:0.9em;">
                    <li>
                      <strong>AC Input Socket (US):</strong> 100-120V~50/60Hz
                      5.5A
                    </li>
                    <li>
                      <strong>DC Input Port (XT60):</strong> 12-60V⎓15A Max
                    </li>
                  </ul>
                  <hr />
                  <h4>Environmental</h4>
                  <ul style="font-size:0.9em;">
                    <li>
                      <strong>Optimal Operating Temperature:</strong> 68°F to
                      86°F (20°C to 30°C)
                    </li>
                    <li>
                      <strong>Charge Temperature:</strong> 32°F to 113°F (0°C to
                      45°C)
                    </li>
                    <li>
                      <strong>Discharge Temperature:</strong> 14°F to 113°F
                      (-10°C to 45°C)
                    </li>
                    <li>
                      <strong>Storage Temperature:</strong>
                      <ul>
                        <li>14°F to 113°F (-10°C to 45°C)</li>
                        <li>Optimal: 68°F to 86°F (20°C to 30°C)</li>
                      </ul>
                    </li>
                    <li>
                      <strong>Operating Altitude:</strong> &lt;3000 m (9842 ft)
                    </li>
                  </ul>
                  <hr />
                  <h4>Communications</h4>
                  <ul style="font-size:0.9em;">
                    <li>
                      <strong>Wi-Fi:</strong> 2.4G
                    </li>
                    <li>
                      <strong>Bluetooth:</strong> Supported
                    </li>
                  </ul>
                </Fragment>
              ),
            },
          ]}
        />
      </Center>
      <Center>
        <SlugHeading tag="h2">App Control</SlugHeading>
        <p>
          The DELTA 3 Air Series pairs with the EcoFlow app to allow for device
          monitoring and customization of default settings. The app is available
          on{" "}
          <Link
            external
            href="https://apps.apple.com/us/app/ecoflow-power-a-new-world/id1506693140"
          >
            iOS
          </Link>{" "}
          and{" "}
          <Link
            external
            href="https://play.google.com/store/apps/details?id=com.ecoflow&hl=en_US"
          >
            Android
          </Link>
          . The screenshots below show all currently available options, ordered
          exactly as they appear in the settings menu.
        </p>

        <ImageSet
          size={6}
          maxShow={6}
          shadow={true}
          images={[
            {
              lg: "/images/products/ecoflow/delta-3-1000-air/lg/20251213_063231000.webp",
              sm: "/images/products/ecoflow/delta-3-1000-air/sm/20251213_063231000.webp",
              alt: "",
            },

            {
              lg: "/images/products/ecoflow/delta-3-1000-air/lg/20251213_210031000.webp",
              sm: "/images/products/ecoflow/delta-3-1000-air/sm/20251213_210031000.webp",
              alt: "Device settings",
            },
            {
              lg: "/images/products/ecoflow/delta-3-1000-air/lg/20251213_210042000.webp",
              sm: "/images/products/ecoflow/delta-3-1000-air/sm/20251213_210042000.webp",
              alt: "Device settings",
            },
            {
              lg: "/images/products/ecoflow/delta-3-1000-air/lg/20251213_210124000.webp",
              sm: "/images/products/ecoflow/delta-3-1000-air/sm/20251213_210124000.webp",
              alt: "Device settings",
            },

            {
              lg: "/images/products/ecoflow/delta-3-1000-air/lg/20251213_060645000.webp",
              sm: "/images/products/ecoflow/delta-3-1000-air/sm/20251213_060645000.webp",
              alt: "Auto timeout",
            },
            {
              lg: "/images/products/ecoflow/delta-3-1000-air/lg/20251213_060658000.webp",
              sm: "/images/products/ecoflow/delta-3-1000-air/sm/20251213_060658000.webp",
              alt: "Device timeout",
            },
            {
              lg: "/images/products/ecoflow/delta-3-1000-air/lg/20251213_060703000.webp",
              sm: "/images/products/ecoflow/delta-3-1000-air/sm/20251213_060703000.webp",
              alt: "LCD screen timeout",
            },
            {
              lg: "/images/products/ecoflow/delta-3-1000-air/lg/20251213_060707000.webp",
              sm: "/images/products/ecoflow/delta-3-1000-air/sm/20251213_060707000.webp",
              alt: "AC timeout",
            },
            {
              lg: "/images/products/ecoflow/delta-3-1000-air/lg/20251213_060712000.webp",
              sm: "/images/products/ecoflow/delta-3-1000-air/sm/20251213_060712000.webp",
              alt: "Screen brightness",
            },
            {
              lg: "/images/products/ecoflow/delta-3-1000-air/lg/20251213_060718000.webp",
              sm: "/images/products/ecoflow/delta-3-1000-air/sm/20251213_060718000.webp",
              alt: "Grid settings",
            },
            {
              lg: "/images/products/ecoflow/delta-3-1000-air/lg/20251213_060744000.webp",
              sm: "/images/products/ecoflow/delta-3-1000-air/sm/20251213_060744000.webp",
              alt: "AC charging speed",
            },
            {
              lg: "/images/products/ecoflow/delta-3-1000-air/lg/20251213_060747000.webp",
              sm: "/images/products/ecoflow/delta-3-1000-air/sm/20251213_060747000.webp",
              alt: "AC charging speed: optimized battery charging",
            },
            {
              lg: "/images/products/ecoflow/delta-3-1000-air/lg/20251213_060750000.webp",
              sm: "/images/products/ecoflow/delta-3-1000-air/sm/20251213_060750000.webp",
              alt: "AC charging speed: quiet charging",
            },
            {
              lg: "/images/products/ecoflow/delta-3-1000-air/lg/20251213_060757000.webp",
              sm: "/images/products/ecoflow/delta-3-1000-air/sm/20251213_060757000.webp",
              alt: "Car input",
            },
            {
              lg: "/images/products/ecoflow/delta-3-1000-air/lg/20251213_060807000.webp",
              sm: "/images/products/ecoflow/delta-3-1000-air/sm/20251213_060807000.webp",
              alt: "X-Boost",
            },
            {
              lg: "/images/products/ecoflow/delta-3-1000-air/lg/20251213_060820000.webp",
              sm: "/images/products/ecoflow/delta-3-1000-air/sm/20251213_060820000.webp",
              alt: "Output port memory",
            },
            {
              lg: "/images/products/ecoflow/delta-3-1000-air/lg/20251213_060826000.webp",
              sm: "/images/products/ecoflow/delta-3-1000-air/sm/20251213_060826000.webp",
              alt: "Charge & discharge limits",
            },
            {
              lg: "/images/products/ecoflow/delta-3-1000-air/lg/20251213_060912000.webp",
              sm: "/images/products/ecoflow/delta-3-1000-air/sm/20251213_060912000.webp",
              alt: "Scheduled tasks",
            },
            {
              lg: "/images/products/ecoflow/delta-3-1000-air/lg/20251213_060915000.webp",
              sm: "/images/products/ecoflow/delta-3-1000-air/sm/20251213_060915000.webp",
              alt: "Create task: new task",
            },
            {
              lg: "/images/products/ecoflow/delta-3-1000-air/lg/20251213_060921000.webp",
              sm: "/images/products/ecoflow/delta-3-1000-air/sm/20251213_060921000.webp",
              alt: "Create task: new task (period)",
            },
            {
              lg: "/images/products/ecoflow/delta-3-1000-air/lg/20251213_065100000.webp",
              sm: "/images/products/ecoflow/delta-3-1000-air/sm/20251213_065100000.webp",
              alt: "Firmware update",
            },
            {
              lg: "/images/products/ecoflow/delta-3-1000-air/lg/20251213_210110000.webp",
              sm: "/images/products/ecoflow/delta-3-1000-air/sm/20251213_210110000.webp",
              alt: "Specifications",
            },

            {
              lg: "/images/products/ecoflow/delta-3-1000-air/lg/20251213_204702000.webp",
              sm: "/images/products/ecoflow/delta-3-1000-air/sm/20251213_204702000.webp",
              alt: "Homepage style: Energy flow",
            },
            {
              lg: "/images/products/ecoflow/delta-3-1000-air/lg/20251213_063317000.webp",
              sm: "/images/products/ecoflow/delta-3-1000-air/sm/20251213_063317000.webp",
              alt: "Energy flow",
            },

            {
              lg: "/images/products/ecoflow/delta-3-1000-air/lg/20251213_204707000.webp",
              sm: "/images/products/ecoflow/delta-3-1000-air/sm/20251213_204707000.webp",
              alt: "Homepage style: Standard",
            },
            {
              lg: "/images/products/ecoflow/delta-3-1000-air/lg/20251213_063242000.webp",
              sm: "/images/products/ecoflow/delta-3-1000-air/sm/20251213_063242000.webp",
              alt: "Standard: Input",
            },
            {
              lg: "/images/products/ecoflow/delta-3-1000-air/lg/20251213_063248000.webp",
              sm: "/images/products/ecoflow/delta-3-1000-air/sm/20251213_063248000.webp",
              alt: "Standard: Output",
            },
          ]}
        />
      </Center>
      <Center>
        <SlugHeading tag="h2">Accessories</SlugHeading>
        <p>
          To lower upfront cost, the unit ships without accessories. Solar and
          car charging cables are sold separately if needed.
        </p>
        <Accordion
          right
          items={[
            {
              preview: (
                <AccordionPreview
                  headingAs="h3"
                  heading="Solar charging"
                  src="/images/products/ecoflow/accessories/solar-to-xt60-xt60i-charging-cable.webp"
                />
              ),
              content: (
                <Fragment>
                  <p>
                    EcoFlow offers both{" "}
                    <Link
                      affiliateData={affiliateMerchants.ecoflow}
                      href="https://us.ecoflow.com/collections/mountable-solar-panels"
                    >
                      mountable
                    </Link>{" "}
                    and{" "}
                    <Link
                      affiliateData={affiliateMerchants.ecoflow}
                      href="https://us.ecoflow.com/collections/portable-solar-panels"
                    >
                      portable
                    </Link>{" "}
                    solar panels, some of which are rigid, flexible,
                    traditional, or bifacial. Using other reputable brands is
                    perfectly fine, but always ensure the total solar array
                    output is within the correct range (12-60V⎓15A) or you could
                    damage the power station.
                  </p>

                  <h4>Solar Accessories</h4>
                  <ul class="none">
                    <li>
                      <PhotoListItem
                        affiliateData={affiliateMerchants.ecoflow}
                        href="https://us.ecoflow.com/collections/delta-3-series-accessories/products/solar-charging-cable?variant=39880496382025"
                        img="/images/products/ecoflow/accessories/solar-to-xt60-xt60i-charging-cable.webp"
                        title="Solar to XT60/XT60i Charging Cable"
                        description={
                          <Fragment>Charge from solar panels</Fragment>
                        }
                        buttonText="EcoFlow"
                        buttonIcon="EcoFlow"
                      />
                    </li>
                    <li>
                      <PhotoListItem
                        affiliateData={affiliateMerchants.ecoflow}
                        href="https://us.ecoflow.com/products/solar-extension-cable?_pos=1&_sid=e350c6fc3&_ss=r&variant=31865877823561"
                        img="/images/products/ecoflow/accessories/solar-extension-cable.webp"
                        title="Solar Extension Cable"
                        description={
                          <Fragment>Provides additional cable length</Fragment>
                        }
                        buttonText="EcoFlow"
                        buttonIcon="EcoFlow"
                      />
                    </li>
                    <li>
                      <PhotoListItem
                        affiliateData={affiliateMerchants.ecoflow}
                        href="https://us.ecoflow.com/products/solar-parallel-connection-cable?variant=31289813729353"
                        img="/images/products/ecoflow/accessories/solar-parallel-connection-cable.webp"
                        title="Solar Parallel Connection Cable"
                        description={
                          <Fragment>Connects solar panels in parallel</Fragment>
                        }
                        buttonText="EcoFlow"
                        buttonIcon="EcoFlow"
                      />
                    </li>
                  </ul>
                </Fragment>
              ),
            },
            {
              preview: (
                <AccordionPreview
                  headingAs="h3"
                  heading="Car charging"
                  src="/images/products/ecoflow/accessories/car-charging-cable.webp"
                />
              ),
              content: (
                <Fragment>
                  <p>
                    You can charge on the road either through your vehicle’s
                    cigarette lighter socket or directly from the battery with
                    an EcoFlow alternator charger.
                  </p>
                  <ul class="none">
                    <li>
                      <PhotoListItem
                        affiliateData={affiliateMerchants.ecoflow}
                        href="https://us.ecoflow.com/products/car-charging-cable?variant=39308519604297"
                        img="/images/products/ecoflow/accessories/car-charging-cable.webp"
                        title="Car Charging Cable"
                        titleSuffix="(100W)"
                        description={
                          <Fragment>
                            Charge from your vehicle's cigarette lighter socket
                          </Fragment>
                        }
                        buttonText="EcoFlow"
                        buttonIcon="EcoFlow"
                      />
                    </li>
                    <li>
                      <PhotoListItem
                        affiliateData={affiliateMerchants.ecoflow}
                        href="https://us.ecoflow.com/products/ecoflow-500w-alternator-charger"
                        img="/images/products/ecoflow/alternator-charger-500w/front.webp"
                        title="500W Alternator Charger"
                        titleSuffix="(500W)"
                        description={
                          <Fragment>
                            Charge from your vehicle's battery
                          </Fragment>
                        }
                        buttonText="EcoFlow"
                        buttonIcon="EcoFlow"
                      />
                    </li>
                  </ul>
                </Fragment>
              ),
            },
          ]}
        />
      </Center>
      <Center>
        <SlugHeading tag="h2">My Verdict</SlugHeading>
        <p>
          The EcoFlow <strong>DELTA 3 Air Series</strong> strikes a balance
          between portability and reliable backup power. These units are not
          intended to run an entire household during long blackouts, but they
          excel at keeping essential low‑power devices online.
        </p>
        <ul>
          <li>
            <strong>DELTA 3 1000 Air:</strong> Lightweight grab-and-go compact
            design.
          </li>
          <li>
            <strong>DELTA 3 2000 Air:</strong> Double the capacity and output
            for longer runtime and higher demands.
          </li>
        </ul>

        <EcoFlowCouponCode
          href="https://us.ecoflow.com/products/delta-3-1000-air-10ms-ups-portable-power-station?variant=54810612793417"
          buttonText="Buy from EcoFlow"
        />

        <p>
          For users who value portability, fast recharging, and UPS protection,
          these units are strong contenders in the mid-range portable power
          station market.
        </p>

        <ButtonList>
          <Button
            affiliateData={affiliateMerchants.ecoflow}
            href="https://us.ecoflow.com/products/delta-3-1000-air-10ms-ups-portable-power-station?variant=54810612793417"
            icon="EcoFlow"
          >
            Buy DELTA 3 1000 Air
          </Button>
          <Button
            affiliate="https://amzn.to/45gpfWv"
            href="https://www.amazon.com/dp/B0G15GWNZQ/"
            secondary
            icon="Amazon"
          >
            Buy on Amazon
          </Button>
        </ButtonList>

        <Tags tags={headerInfo.tags} brands={headerInfo.brands} />
      </Center>
      <Center>
        <h3>Related</h3>
        <ul class="none">
          <li>
            <ReviewItem href={namedRoutes.ecoflow.d3maxPlus} />
          </li>
          <li>
            <ReviewItem href={namedRoutes.ecoflow.vanlife} />
          </li>
          <li>
            <ReviewItem href={namedRoutes.powerSystems} />
          </li>
          <li>
            <ReviewItem href={namedRoutes.ecoflow.altCharger.gen2} />
          </li>
        </ul>
      </Center>
      <Questions />
      <Center>
        <Author
          author
          published={headerInfo.datePublished}
          updated={headerInfo.dateModified}
        />
      </Center>
      <StickyButtons
        title="EcoFlow DELTA 3 1000 Air"
        description={
          <Fragment>
            $309 <s>$499</s> | 960Wh
          </Fragment>
        }
      >
        <Button
          affiliateData={affiliateMerchants.ecoflow}
          href="https://us.ecoflow.com/products/delta-3-1000-air-10ms-ups-portable-power-station?variant=54810612793417"
          icon="EcoFlow"
        >
          View on EcoFlow
        </Button>
        <Button
          affiliate="https://amzn.to/45gpfWv"
          href="https://www.amazon.com/dp/B0G15GWNZQ/"
          secondary
          icon="Amazon"
        >
          View on Amazon
        </Button>
      </StickyButtons>
    </Editorial>
  </div>
);

export default Page;
